import { defineMessages } from 'react-intl';

export default defineMessages({
  app: {
    id: 'app.name',
    defaultMessage: 'React Application',
  },
  servicenotfound: {
    id: 'home.servicenotfound',
    defaultMessage: 'Service not found.',
  },
  servicefetch: {
    id: 'home.servicefetch',
    defaultMessage: 'Service is fetch.',
  },
  serviceDisable: {
    id: 'home.service.disable',
    defaultMessage: 'Opps Service Disable.',
  },
  findServiceText: {
    id: 'home.findServiceText',
    defaultMessage: 'Search your provider',
  },
  sticky: {
    text: {
      id: 'home.stickyForm',
      defaultMessage: `If you don't see your provider or experience\nany difficulties, let us know `,
    },
    btn: {
      id: 'home.stickyFormBtn',
      defaultMessage: 'here',
    },
  },
  unavailable: {
    title: {
      id: 'home.unavailable.title',
      defaultMessage: 'Something went wrong',
    },
    desc: {
      id: 'home.unavailable.desc',
      defaultMessage:
        'This page failed to load. Please check your connection and try again.',
    },
    btn: {
      id: 'home.unavailable.btn',
      defaultMessage: 'TRY AGAIN',
    },
  },
});
